import { AppKind } from '@core/tellent-types';

export const readBootstrapDataFromUrl = () => {
  const path = window.location.pathname.split('/');
  const isDynamic = window.location.hostname.startsWith('dynamic.');
  if (isDynamic) {
    const [_, dynamic, app, appKind] = path;
    return {
      appKind: <`${AppKind}`>appKind,
      baseHref: `${dynamic}/${app}/${appKind}`,
    };
  } else {
    const [_, appKind] = path;
    return {
      appKind: <`${AppKind}`>appKind,
      baseHref: appKind,
    };
  }
};
